import React from 'react';
import { ButtonPrimary } from 'ui';
import { CodeMappingTileProps, SinglePickerChangeModel } from './types';
import { FaArrowDown, FaArrowRight, FaCopy } from 'react-icons/fa';
import { CodeValue } from 'app/area/code-mappings/components/code-value';
import { ExternalValue } from 'app/area/code-mappings/components/external-value';
import styles from './code-mapping-tile.scss';

export const CodeMappingTile: React.FC<CodeMappingTileProps> = ({
  codeData, displayCopyToAll, description, code, codeCategory, edited, metadata,
  codetableOptions, validation, translation, codetableAccess, updatingExternalValue,
  loadMetadata, modifyCode, copyToAll, loadCodetableOptions, loadCodetablesAccess, loadCategoryOptions
}) => {

  const updateCode = (value: SinglePickerChangeModel) => {
    modifyCode({ value: value?.value, description: value?.description, disabled: value?.disabled }, value?.category);
  };

  const copyToAllMappings = (e: React.MouseEvent) => {
    e.preventDefault();
    copyToAll(codeData.id, codeData.codetable.value, code, codeCategory);
  };

  const codeItem = {
    codetable: { value: codeData.codetable?.value, description: codeData.codetable?.description, ctg: codeData.codetable?.ctg },
    code: {
      value: code?.value,
      description: code?.description,
      ...(!!code?.disabled && { disabled: new Date(code?.disabled) })
    },
    codeCategory: { value: codeCategory?.value }
  };

  return <ol className={`${styles.tileContent} ${edited ? styles.edited : ''}`}>
    <div className="row">
      <div className="col-lg-5 col-sm-12 position-relative">
        <ExternalValue id={codeData.id} label={translation.external_value} description={description} />
        <FaArrowRight className={styles.arrowRight} />
        <FaArrowDown className={styles.arrowDown} />
      </div>
      <div className="col-lg-5 col-sm-12">
        <CodeValue
          codeItem={codeItem}
          externalValue={codeData.id}
          validation={validation}
          codetableOptions={codetableOptions}
          translation={translation}
          loadCodetableOptions={loadCodetableOptions}
          loadCategoryOptions={loadCategoryOptions}
          codetableAccess={codetableAccess}
          loadCodetablesAccess={loadCodetablesAccess}
          loadMetadata={loadMetadata}
          metadata={metadata}
          onChange={updateCode} />
      </div>
      {displayCopyToAll ? <div className={`col-lg-2 col-sm-12 ${styles.copyToAll}`}>
        <ButtonPrimary classNames="w-100" onClick={copyToAllMappings} disabled={updatingExternalValue}>
          <FaCopy /> {translation.copy_to_all}</ButtonPrimary>
      </div> : null}
    </div>
  </ol>;
};
